export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 border-b border-slate-800 pb-12">
          {/* Brand Info */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
              <div className="h-8 w-8 rounded-full bg-red-600 flex items-center justify-center text-xs font-bold">
                RI
              </div>
              <span className="text-xl font-bold tracking-tight">
                Ruwan Indika
              </span>
            </div>
            <p className="text-slate-400 text-sm max-w-xs leading-relaxed">
              Authorized Wealth Planner at AIA Insurance Lanka Limited.
              Dedicated to protecting Sri Lankan families with integrity and
              care.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-6 text-sm font-semibold uppercase tracking-wider">
            <a href="#home" className="hover:text-red-500 transition-colors">
              Home
            </a>
            <a href="#about" className="hover:text-red-500 transition-colors">
              My Story
            </a>
            <a
              href="#services"
              className="hover:text-red-500 transition-colors"
            >
              Plans
            </a>
            <a href="#contact" className="hover:text-red-500 transition-colors">
              Consultation
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Changed text-center for mobile 
              Added md:text-left for desktop 
          */}
          <div className="text-center md:text-left text-xs font-medium text-slate-500 uppercase tracking-[0.2em]">
            © {currentYear} Ruwan Indika. All rights reserved.
          </div>

          {/* Watermark Section */}
          <div className="flex items-center justify-center md:justify-end gap-6 text-[10px] font-bold uppercase tracking-widest text-slate-500">
            {/* AstroSoft Technology Watermark */}
            <a
              href="https://astrosoft.lk"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-1 transition-colors hover:text-white"
            >
              Developed by
              <span className="text-slate-400 transition-colors group-hover:text-blue-500">
                AstroSoft Technology
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
